import React from 'react';
import * as cls from './easy-installation.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

export const EasyInstallation = ({ url }) => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Easy Installation
      </Typography>

      <div className={cls.wrapper}>
        <div>
          <ul>
            <li>
              <Typography>Wi-fi enabled</Typography>
            </li>
            <li>
              <Typography>
                Over the top clamp in fuse box on Installation. No rewiring
              </Typography>
            </li>
            <li>
              <Typography>
                Quick-start guide and in-app setup walkthrough
              </Typography>
            </li>
          </ul>

          <a href={url} rel="noopener noreferrer" target="_blank">
            <img
              alt="Order Now on Amazon"
              src={`${IMG_PATH}/amazon-shop/order-now-on-amazon.png`}
            />
          </a>
        </div>

        <img
          alt="Quick install, no rewiring"
          src={`${IMG_PATH}/amazon-shop/easy-installation.png`}
        />
      </div>
    </Section>
  );
};
